<div class="product-view-details card9-wrap-details" [class.is-rtl]="isRtl$$()">
    @if (templateConfiguration.textPosition !== 'none') {
        <div class="card9-contents pt-16" [class.border-b2]="sublineInBundle">
            <!-- Product title -->
            <div class="is-flex content-sp-between wrap-details-top">
                @if (!hasBundle && templateConfiguration?.showName) {
                    <div
                        class="title-m ttu {{ templateConfiguration?.productDetailClass }} product-title"
                        [ngClass]="{
                            'pb-1 border-b2': templateConfiguration.showLinesInDetails,
                            'name-width-product has-ellipsis mb-4': !templateConfiguration.showLinesInDetails,
                            'product-with-colors': showColors
                        }"
                        [ngStyle]="{ color: templateConfiguration?.styles?.['fontColor'] }"
                    >
                        <span class="cursor-pointer" (click)="onClickButton($event)" [ngStyle]="{ color: colorStyle }">
                            {{ product?.name }}
                        </span>
                    </div>
                }

                <!--Product info -->
                @defer (when showColors) {
                    <div class="is-flex flex-wrap align-top">
                        <!-- Color selector -->
                        <product-view-color-selector
                            class="color-wrap color-square"
                            [colors]="product.colors"
                            [selectedColor]="product.status?.selectedColor"
                            (checkMoreColors)="onClickButton()"
                            [templateConfiguration]="templateConfiguration"
                            [colorStyle]="colorStyle"
                        >
                        </product-view-color-selector>
                    </div>
                }
            </div>

            <!-- Product prices  -->
            @defer (when showPrices) {
                <product-prices
                    class="text-l"
                    [productPrices]="priceInfo"
                    [hasPromotion]="product.status?.selectedColor?.sizes[0]?.promotionId"
                    [templateConfiguration]="templateConfiguration"
                    [showPricesInFlexMode]="true"
                    [pricesInTwoColumns]="!!priceInfo?.originalPrice?.value"
                    [alternativePricesClass]="'title-m ttu'"
                    [hidePriceText]="templateConfiguration.hidePriceText"
                    [pricesClasses]="{ titleLarge: true, container: 'mb-4' }"
                    [colorStyle]="colorStyle"
                ></product-prices>
            }

            @if (templateConfiguration?.showDescription && product.longDescription) {
                <span class="title-s ttu"> {{ product.longDescription | uppercase }}. </span>
            }

            @if (hasBundle && templateConfiguration?.showViewBundleProducts !== false) {
                <div class="is-flex" [ngStyle]="{ color: templateConfiguration.styles && templateConfiguration.styles['fontColor'] }">
                    <a
                        href="{{ product.locationPath }}"
                        class="cursor-pointer"
                        [ngClass]="[
                            templateConfiguration?.showBundleName && !!templateConfiguration?.productDetailClass
                                ? templateConfiguration.productDetailClass
                                : 'text-l'
                        ]"
                        [ngStyle]="{ color: colorStyle }"
                        (click)="onClickButton($event)"
                    >
                        @if (templateConfiguration?.showBundleName) {
                            {{ product.name }}
                        } @else {
                            {{ 'dev.product.viewBundleProducts' | translate }}
                        }
                    </a>
                </div>
            }

            @if (templateConfiguration?.showTags) {
                <div
                    class="tag-wrapper grid-product-list"
                    [ngStyle]="{ color: templateConfiguration.styles && templateConfiguration.styles['fontColor'] }"
                >
                    @for (item of attributesInMocaco$ | async; track item) {
                        <span class="product-tag text-m pr-8 mt-4" [ngStyle]="{ color: colorStyle }">
                            @switch (item.name) {
                                @case (productAttributeEnum.MADEIN_NEW) {
                                    {{ 'dev.general.new' | translate }}
                                }
                                @case (productAttributeEnum.NEW) {
                                    {{ 'dev.general.new' | translate }}
                                }
                                @case (productAttributeEnum.VICOM_3D_VISOR) {
                                    {{ 'dev.product.view3D' | translate }}
                                }
                                @case (productAttributeEnum.XCUSTOMIZABLE) {
                                    {{ 'dev.product.customizable' | translate }}
                                }
                                @default {
                                    {{ item.value }}
                                }
                            }
                        </span>
                    }
                </div>
            }

            @if (templateConfiguration?.showPromotions) {
                <product-promotion-dates [product]="product" [fontColor]="colorStyle"></product-promotion-dates>
            }
        </div>
    }
</div>
